<template>
  <div
    :class=" getBackgroudnClass()"
  >{{ getDayData() }}
  </div>
</template>

<script setup lang="ts">
import { CalendarDayModel } from '@/services/entities/Reporting/CalendarDayModel';

const props = defineProps<{ dayData: CalendarDayModel }>();

function getBackgroudnClass() {
  const common = 'calendar-day-visual';  
  if ((props.dayData.hours === 0) && (!props.dayData.outOfOffice))
    return  common;
  if (props.dayData.isAbsent && props.dayData.outOfOffice) {
    return `${common} combo-absent-ooo`;
  } else if (props.dayData.isAbsent && props.dayData.isPresent) {
    return `${common} combo-absent-present`;
    // other combinations are in simplicity not possible - cannot be determined from the data model
  } else if (props.dayData.isAbsent) {
    return `${common} absent`;
  } else if (props.dayData.outOfOffice) {
    return `${common} out-of-office`;
  } else if (props.dayData.isPresent) {
    return `${common} present`;
  }
}

const getDayData = (): string => {
  if (props.dayData.hours == null) {
    return "";
  }
  return props.dayData.hours > 0
    ? `${props.dayData.hours}`
    : "-";
}

</script>

<style scoped>
.present {
  background-color: #9befd4;
}

.absent {
  background-color: #fdd860;
}

.out-of-office {
  background-color: #8fbcff;
}

.combo-absent-ooo {
  background-image: linear-gradient(to right, #fdd860, #8fbcff);
}

.combo-absent-present {
  background-image: linear-gradient(to right, #fdd860, #9befd4);
}

.calendar-day-visual {  
  width: 2.2rem;
  min-height: 1.5rem;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  font-size: 1em;
  font-weight: 400;
}
</style>